import { forwardRef } from 'react';
import clsx from 'clsx';
import { ChevronDown } from 'lucide-react';
import styles from './Select.module.css';

/** Select estilizado. `options` = [{ value, label }] ou children manuais. */
const Select = forwardRef(function Select(
  { label, error, className, id, options, placeholder, children, ...props },
  ref
) {
  return (
    <div className={clsx(styles.wrap, className)}>
      {label && (
        <label htmlFor={id} className={styles.label}>
          {label}
        </label>
      )}
      <div className={styles.field}>
        <select
          id={id}
          ref={ref}
          className={clsx(styles.select, error && styles.hasError)}
          {...props}
        >
          {placeholder && <option value="">{placeholder}</option>}
          {options
            ? options.map((o) => (
                <option key={o.value} value={o.value}>
                  {o.label}
                </option>
              ))
            : children}
        </select>
        <ChevronDown size={16} className={styles.chevron} aria-hidden />
      </div>
      {error && <span className={styles.error}>{error}</span>}
    </div>
  );
});

export default Select;
